// All user-visible strings (Thai). Only the about block's lang="en" paragraph in index.html is
// English. Every control reads its label/copy from here — never a hardcoded Thai literal in main.js.
import { boxDims, HW } from '../doc.js';
const S = {
  title: "ถาดแบ่งช่อง",
  view: {
    "2d": "แก้ช่อง",
    "3d": "ดู 3D",
  },
  gCell: "ช่องที่เลือก",
  gSize: "ขนาดถาด",
  gWalls: "ผนัง",
  gStack: "ซ้อนถาด",
  selName: (col, row, c) => `คอลัมน์ ${col + 1} · ช่อง ${row + 1} — ${c} มม.`,
  colSize: "ความกว้างคอลัมน์",
  cellSize: "ความลึกช่อง",
  kinds: {
    auto: "อัตโนมัติ",
    "1/2": "1/2",
    "1/3": "1/3",
    "2/3": "2/3",
    mm: "กำหนด มม.",
  },
  split: "แบ่งช่อง",
  addCol: "เพิ่มคอลัมน์",
  del: "ลบช่อง",
  w: "กว้าง (มม.)",
  d: "ลึก (มม.)",
  bed: "ฐานพิมพ์ (มม.)",
  bedOption: (w, d) => `${w} × ${d}`,
  bedWarn: (w, d) => `ถาดใหญ่กว่าฐานพิมพ์ ${w} × ${d} มม. — อาจพิมพ์ไม่ได้ในชิ้นเดียว`,
  wall: "ความหนาผนัง",
  fillet: "ความโค้งมุม",
  divider: "ความสูงผนังกั้น",
  stackable: "ซ้อนกันได้ (ขอบล็อกบน-ล่าง)",
  clearance: "ระยะเผื่อสวม",
  stackNote: (h) => `ซ้อน 3 ใบ สูง ${Math.round((3 * (h - 1) + 1) * 10) / 10} มม. · ใบต่อไปเพิ่มใบละ ${Math.round((h - 1) * 10) / 10} มม.`,
  size: (w, d, h) => `${w} × ${d} × ${h} มม.`,
  gBox: "กล่องใส่ถาด",
  boxOn: "ทำกล่อง + ฝา",
  trayCount: "จำนวนถาด",
  partLabel: "ชิ้นที่ดาวน์โหลด",
  explode: "แยกชิ้น",
  parts: {
    tray: "ถาด",
    box: "กล่อง",
    latch: "ตัวล็อก",
    lid: "ฝา",
  },
  boxNote: (wo, dd, hb, n) => `กล่อง ${wo} × ${dd} × ${hb} มม. · พิมพ์ถาด ${n} ใบ`,
  hwNote: (hinges) => `น็อต ${HW.screw} มม. × ${hinges} · หมุด ${HW.pin} × ${HW.pinLen} มม. × 1 (หรือเส้นพลาสติก 1.75)`,
  bedWarnPart: (part, w, d) => `${part} พิมพ์ ${w} × ${d} มม. — ใหญ่กว่าฐานพิมพ์ อาจพิมพ์ไม่ได้ในชิ้นเดียว`,
  tallWarn: (part, z) => `${part} สูง ${z} มม. — เกินความสูงพิมพ์ของเครื่องส่วนใหญ่`,
  problem: {
    "auto-squeezed": "ช่องอัตโนมัติไม่เหลือที่ — ลดขนาดช่องที่กำหนดไว้",
    "too-small": "ช่องเล็กเกินไป (ต้องกว้างอย่างน้อย 2 เท่าของผนัง)",
    overflow: "ขนาดที่กำหนดรวมกันเกินขนาดถาด",
    "fractions-over": "สัดส่วนรวมกันเกิน 1",
    "corner-clipped": "ช่องมุมถูกขอบโค้งตัด — ลดความโค้งมุม",
    "too-shallow": "ถาดตื้นเกินไป — เพิ่มความสูงหรือลดความหนาผนัง",
    "stack-wall": "ผนังบางเกินไปสำหรับขอบล็อก — เพิ่มความหนาผนังหรือลดระยะเผื่อ",
    "stack-shallow": "ถาดตื้นเกินไปสำหรับการซ้อน — เพิ่มความสูง",
    "box-narrow": (doc) => `กล่องแคบเกินไปสำหรับบานพับ — ถาดต้องกว้างอย่างน้อย ${Math.round(boxDims(doc).minW * 10) / 10} มม. หรือลดความโค้งมุม`,
  },
  dlstl: "STL",
  copied: "คัดลอกแล้ว",
  fatal: "โหลดตัวคำนวณไม่สำเร็จ — ลองรีเฟรชหน้า",
  unitMm: " มม.",
  pct: (v) => `${v}%`,

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "ออกแบบถาดแบ่งช่องสำหรับจัดระเบียบลิ้นชัก โต๊ะ และกล่องเครื่องมือ กำหนดขนาดและช่องได้เอง ทำขอบให้ซ้อนกันได้ ดาวน์โหลดไฟล์ 3MF/STL ใช้ฟรี",
};
export default S;
